export default __webpack_public_path__ + "static/media/me.e7f41279.png";